import styled from '@emotion/styled';

const LangSwitchWrapper = styled.div`
position: absolute;
right: 4rem;
  top: 1.5rem;
  z-index: 999
`;

export default LangSwitchWrapper;
